import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    // Copy the active template prints that belongs to the block rather than to one clip —
    // the duet's two pills, the series title. One JSON column in Core, so a new template is
    // a frontend-only change.
    data: {},
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const shortsSlice = createSlice({
  name: 'shorts',
  initialState,
  reducers: {
    shortsStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#ECECF0',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        data: blockContent.data ?? {},
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    shortsClear: () => initialState,

    shortsUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    shortsUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    shortsUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    shortsUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { shortsStore, shortsClear, shortsUpdateIsLoading, shortsUpdateIsActive, shortsUpdateBlockContent, shortsUpdateBlockDesign } = shortsSlice.actions;

export const selectShortsIsLoading = (state) => state.shorts.isLoading;

export const selectShortsId = (state) => state.shorts.id;
export const selectShortsUID = (state) => state.shorts.uid;
export const selectShortsSID = (state) => state.shorts.sid;

export const selectShortsBlockContent = (state) => state.shorts.blockContent;
export const selectShortsData = (state) => state.shorts.blockContent.data;
export const selectShortsBlockDesign = (state) => state.shorts.blockDesign;
export const selectShortsSortItems = createSelector([selectShortsBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectShortsItemDesign = (state) => state.shorts.itemDesign;
export const selectShortsContainerDesign = (state) => state.shorts.containerDesign;

export default shortsSlice.reducer;
